/* eslint-disable */
export default function trustPilotInit() {
    if (document.cookie.indexOf('TRUSTPILOT') > -1) {
        var trustPilotScript = document.createElement('script');
        trustPilotScript.setAttribute('src', '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
        document.head.appendChild(trustPilotScript);
        $('.js-trustpilot_container').css('display', 'block');
    }
    else {
        $('.js-trustpilot_container').css('display', 'none');
    }
}